<template>
  <div class="">
  
    <el-dialog title="合作商发卡" :visible.sync="sendShow" width="30%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="卡券类型"> 海马会员卡 </el-form-item>
        <div>
          <el-form-item label="持卡人姓名" required>
            <el-input
              v-model="name"
            >
            </el-input>
          </el-form-item>
           <el-form-item label="电话" required>
            <el-input
              v-model="phone"
            >
            </el-input>
          </el-form-item>
        </div>
      
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-left: 30px" @click="sendShow = false"
          >取消</el-button
        >
        <el-button
          style="margin-left: 20px"
          type="primary"
          @click="generateCoupon"
          :loading="loading"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  props: {
    cooperator: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      sendShow: false,
      loading: false,
      card:{},
      coop_id:'',
      name:'',
      phone:'',
    };
  },
  mounted() {
    this.coop_id = this.$route.query.id;
  },


  methods: {
 
  
    //合作商发卡
    generateCoupon() {
     
      let data = {
        name: this.name,
        phone: this.phone,
        coop_id: this.coop_id,
        card_id: this.card.id,
      };
      this.loading = true;
      this.$axios
        .post("/user/mechanismCard/sendCoopCard", data)
        .then((res) => {
          this.$message({ message: res.data.message });
          this.sendShow = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    open(card) {
     this.name = ''
     this.phone = ''
      this.sendShow = true;
     this.card = card
    }
  },
};
</script>

<style lang="less" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
a:hover {
  color: #333;
}

.table {
  height: 30px;
  line-height: 30px;
  border: 1px solid #333;
  border-bottom: none;
  padding: 0 10px 0 2px;
}
</style>